
import { getMediaRecords, uploadToMedia } from '@/api/local-material'
import { getMedias } from '@/api/constant'
import CreateForm from '@/components/local-material/mediaRecord/create/Create.vue'

let baseRefreshTime = 30
export default {
    components: {
        CreateForm
    },
    props: {
        showMediaRecordPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
        mediaType: String,
        advertiser_id: {
            type: Number,
            default: () => null
        },
    },
    data () {
        return {
            advertiser_name: '',
            medias: [],
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            columns: [
                {
                    width: 80, title: '媒体', dataIndex: 'media', customRender: item => {
                         return this.$helper.getItemName(this.medias, item) || '-'
                    } ,
                },
                { width: 200, title: '所属主体', dataIndex: 'company', ellipsis: true },
                { width: 100, title: '账户类型', dataIndex: 'account_type', customRender: item => {
                    return item === 2 ? '组织' : '广告主'
                }},
                { width: 160, title: '所属广告主ID', dataIndex: 'advertiser_id', ellipsis: true },
                { width: 180, title: '所属广告主名称', dataIndex: 'advertiser_name', ellipsis: true },
                { width: 180, title: '组织名称', dataIndex: 'organize_name', ellipsis: true, customRender: item => item || '-' },
                // { width: 260, title: '所属广告主', dataIndex: '', customRender: item => {
                //     return "【ID:"+ item.advertiser_id +"】" + item.advertiser_name
                // } },
                { width: 260, title: '视频ID', dataIndex: 'video_id', ellipsis: true },
                { width: 200, title: '素材ID', dataIndex: 'marterial_id', ellipsis: true },
                { width: 200, title: '失败原因', dataIndex: 'error_msg', ellipsis: true },
                { width: 120,title: '状态', dataIndex: '', scopedSlots: { customRender: 'status' }}
                // { width: 150,title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' }}
            ],
            queryParam: {},
            tableHeight: 0,
            mediaAccounts: [],
            showUploadForm: false,
            timer: null,
            refreshTime: baseRefreshTime, //刷新倒计时
        }
    },
    computed: {},
    watch: {
      
    },
    mounted () {
        getMedias().then(res => { this.medias = res.data.list || [] })
        this.getList()
    },
    methods: {
        close() {
            clearInterval(this.timer)
            this.$emit('update:showMediaRecordPage', false)
            this.$emit('success')
        },
        handleCancel() {
            clearInterval(this.timer)
            this.$emit('update:showMediaRecordPage', false)
            this.$emit('success')
        },

        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
        handleTableChange(pagination) {
            const pager = {...this.pagination}
            pager.current = pagination.current
            this.pagination = pager
            this.getList()
        },
        getList() {
            this.loading = true
            const pagination = {...this.pagination}
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                code: this.model.code,
            })
            getMediaRecords(json, this.mediaType).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })

            //需要销毁老的定时器，再重新创建一个新的定时器
            clearInterval(this.timer)
            this.refreshTime = baseRefreshTime

            this.timer = setInterval(() => {
                this.refreshTime--
                if (this.refreshTime <= 0) {
                    clearInterval(this.timer)
                    this.refresh()
                }
            }, 1000)
        },
        refresh() {
            this.getList()
        },
        search() {
            this.pagination.current = 1
            this.getList()
        },
        resetSearch() {
            this.queryParam = {}
            this.getList()
        },
        accessTo(route) {
            return this.$helper.accessTo('LocalMaterialController', route)
        },
        uploadToMedia (type = 1, media = 2) {
            this.showUploadForm = true
            this.model.media = media
            this.model.media_name = '巨量'
            this.model.mediaStr = 'juliang'
            if (media == 1) {
                this.model.media_name = '快手'
                this.model.mediaStr = 'kuaishou'
            } 
          
            this.model.up_type = type
        },
        closeUploadForm() {
            this.showUploadForm = false
            this.getList()
        },
        clickRetry (record) {
            console.log(record)

            uploadToMedia({
                local_material_id: record.local_material_id,
                advertiser_id: record.adv_id,
                is_retry: true
            }).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('提交任务成功，请等待！')
                    setTimeout(() => {
                        this.getList()
                    }, 2);
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })

        }
    }
}